import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingService } from 'src/app/core/onboarding.service';
import { UserService } from 'src/app/core/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  standalone: false
})
export class OnboardingComponent {

  user?: User;
  stepIndex: number = 0;
  options1: string[] = ['⏱️ Ich verliere zu viel Zeit mit dem Erstellen von Karten', '😅 Ich lerne viel, vergesse es aber wieder schnell', '🤯 Manche Themen sind schwer zu verstehen', '🫠 Mir fällt es oft schwer mich zu motivieren'];
  options2: string[] = ['🎓 Für das Studium', '🎒 Für die Schule', '📖 Sonstiges'];
  options3: string[] = ['💯 Bestnoten (1,0 Schnitt)', '🏝️ Stressfreie Klausurenphase (mehr Zeit)', '🤓 Stoff endlich verstehen (tiefes Lernen)'];

  userType?: string;
  biggestChallenge?: string;
  registrationGoal?: string;

  activatePremiumTrial?: boolean;

  loading: boolean = false;

  constructor(
    private userService: UserService,
    private router: Router,
    private onboardingService: OnboardingService
  ) {}

  ngOnInit() {
    this.userService.getUser().subscribe(user => {
      this.user = user;
    });
  }

  nextStep() {
    if (this.stepIndex === 6) {
      this.finishOnboarding();
    } else {
      this.stepIndex++;
    }
  }

  biggestChallengeChange(biggestChallengeAnswer: string) {
    switch (biggestChallengeAnswer) {
      case '⏱️ Ich verliere zu viel Zeit mit dem Erstellen von Karten':
        this.biggestChallenge = 'slow_creation_issues';
        break;
      case '😅 Ich lerne viel, vergesse es aber wieder schnell':
        this.biggestChallenge = 'remembering_issues';
        break;
      case '🤯 Manche Themen sind schwer zu verstehen':
        this.biggestChallenge = 'understanding_issues';
        break;
      case '🫠 Mir fällt es oft schwer mich zu motivieren':
        this.biggestChallenge = 'motivation_issues';
        break;
      default:
        this.biggestChallenge = 'error';
        break;
    }
    this.nextStep();
  }

  userTypeChange(userType: string) {
    switch (userType) {
      case '🎓 Für das Studium':
        this.userType = 'student';
        break;
      case '🎒 Für die Schule':
        this.userType = 'pupil';
        break;
      case '📖 Sonstiges':
        this.userType = 'other';
        break;
      default:
        this.userType = 'error';
        break;
    }
    this.nextStep();
  }

  registrationGoalChange(registrationGoal: string) {
    switch (registrationGoal) {
      case '💯 Bestnoten (1,0 Schnitt)':
        this.registrationGoal = 'best_grades';
        break;
      case '🏝️ Stressfreie Klausurenphase (mehr Zeit)':
        this.registrationGoal = 'stress_free_exam_phase';
        break;
      case '🤓 Stoff endlich verstehen (tiefes Lernen)':
        this.registrationGoal = 'deep_understanding';
        break;
      default:
        this.registrationGoal = 'error';
        break;
    }
    this.nextStep();
  }

  finishOnboarding() {
    this.loading = true;
    this.onboardingService.completeOnboarding(this.biggestChallenge!, this.userType!, this.registrationGoal!, this.activatePremiumTrial!).subscribe(() => {
      this.router.navigate(['courses']);
      this.userService.loadUser().subscribe();
    });
  }
}
